<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="d-flex">
      <template v-slot:default="{ open }">
        <span class="font-weight-medium text-h6">Dados do Cliente</span>
        <div
          v-if="open"
          class="d-flex justify-end mr-2"
        >
          <secao-default-chip></secao-default-chip>
        </div>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <formulario-default-campos-cliente></formulario-default-campos-cliente>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import {
  mdiCog,
  mdiCheckBold,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import SecaoDefaultChip from '../SecaoDefaultChip.vue'
import FormularioDefaultCamposCliente from './FormularioDefaultCamposCliente.vue'

export default {
  components: {
    SecaoDefaultChip,
    FormularioDefaultCamposCliente,
  },

  setup() {
    const isConfigurarSecaoDialogOpen = ref(false)

    return {
      isConfigurarSecaoDialogOpen,
      icons: {
        mdiCog,
        mdiCheckBold,
      },
    }
  },
}
</script>
